exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] ._AjM0lIpPQK-noaC3T41b{padding:0 16px}._39Wb0rLg8iY6zilq9O4HFx{font-size:14px;font-weight:400;color:\"[theme:themeDarkAlt, default:#005A9E]\";height:48px;overflow:hidden}html[dir] ._39Wb0rLg8iY6zilq9O4HFx{padding:0}html[dir=ltr] ._39Wb0rLg8iY6zilq9O4HFx{float:right}html[dir=rtl] ._39Wb0rLg8iY6zilq9O4HFx{float:left}._39Wb0rLg8iY6zilq9O4HFx:active,._39Wb0rLg8iY6zilq9O4HFx:hover{color:\"[theme:themeDarkAlt, default:#005A9E]\"}", ""]);
// Exports
exports.locals = {
	"wrapper": "_AjM0lIpPQK-noaC3T41b",
	"linkButton": "_39Wb0rLg8iY6zilq9O4HFx"
};